import { FC } from 'react';
import { PageViewportLayout } from '../template';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useModal } from 'core';
import { Spinner } from '../../pages/projectEdit/spinner';
import { useTheme } from 'styled-components';
import { ErrorPage, ErrorPageButtons } from 'shared/pages/error/ErrorPage';
import { Designer } from '@brg/api';

export const ProjectEditFrameError: FC<{ id: string, isModalProject?: boolean }> = ({ id, isModalProject }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.cannot_edit')}
                buttons={isModalProject ? ErrorPageButtons.NOTHING : ErrorPageButtons.BACK_MAIN}
            />
        </PageViewportLayout>
    );
};

export const ProjectFrameError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.undefined')}
            />
        </PageViewportLayout>
    );
};

export const ProjectEditFrameUpdateError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.update')}
            />
        </PageViewportLayout>
    );
};

export const ProjectEditFrameLoading: FC<{ id: string, text: string }> = ({ id, text }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout justify={'center'} align={'center'}>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {text || t('project_edit.frames.loading')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const ProjectEditFrameCreating: FC<{ id: string, text: string }> = ({ id, text }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {text || t('project_edit.frames.creating_the_project')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <FlexBox offsetBottom={16}>
                </FlexBox>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const ProjectEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.cannot_edit')}
            />
        </PageViewportLayout>
    );
};

export const TeamEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.cannot_edit_team')}
            />
        </PageViewportLayout>
    );
};

export const TeamEditFrameDeletedTeam: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('teams.adminPage.errors.deleted_team')}
                buttons={ErrorPageButtons.PROFILE}
                id={id}
            />
        </PageViewportLayout>
    );
};

export const TeamEditFrameDraftTeam: FC<{ teamId: string, owner?: Designer }> = ({ teamId, owner }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.undefined')}
                buttons={ErrorPageButtons.BACK_MAIN}
                id={teamId}
            />
        </PageViewportLayout>
    );
};

export const NotFoundChannel: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('teams.adminPage.errors.not_found_channel')}
                buttons={ErrorPageButtons.BACK_MAIN}
            />
        </PageViewportLayout>
    );
};

export const ChatAccessDenied: FC = () => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('teams.adminPage.errors.chat_access_denied')}
                text={t('teams.adminPage.errors.subscribe_to_mediiia')}
                buttons={ErrorPageButtons.CLOSE}
            />
        </PageViewportLayout>
    );
};

export const ChatUnauthorized: FC = () => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('chat.auth.title')}
                text={t('chat.auth.subtitle')}
                buttons={ErrorPageButtons.NEED_AUTH}
            />
        </PageViewportLayout>
    );
};



export const CompetitionEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('competition_edit.frames.forbidden')}
                onBackClick={() => window.open('/', '_SELF')}
            />
        </PageViewportLayout>
    );
};

export const WrongContextForEditFrame: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.wrong_context')}
            />
        </PageViewportLayout>
    );
};

export const EditLockedByAuthorFrame: FC<{
    id?: string,
    accaunt?: { name?: string },
    account?: { name?: string },
    editorName?: string,
    entityLabel?: string,
    ownerRole?: string,
}> = ({ id, accaunt, account, editorName, entityLabel = 'модуль', ownerRole = 'автором' }) => {
    const authorName = accaunt?.name || account?.name || editorName || '';
    const history = useHistory();
    const modal = useModal();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title="Редактирование заблокировано"
                text={`На данный момент ${entityLabel} редактируется ${ownerRole}${authorName ? ` - ${authorName}` : ''}`}
                id={id}
                buttons={ErrorPageButtons.MAIN_ONLY}
                onMainClick={() => {
                    modal.hide();
                    history.push('/');
                }}
            />
        </PageViewportLayout>
    );
};



export const ProjectEditFrameCompetition: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text="Проект участвует в конкурсе, его нельзя редактировать."
            />
        </PageViewportLayout>
    );
};

export const ProjectEditFrameCompetitionRequestSended: FC<{ onBackClick: () => void }> = ({ onBackClick }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'} direction='column' directionMobile='column'>
            <ErrorPage
                title={t('project_edit.frames.success')}
                text="Ваша анкета находится на рассмотрении у модератора."
                onBackClick={onBackClick}
            />
        </PageViewportLayout>
    );
};

export const LoadingSpinner: FC = () => {
    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <Spinner />
        </PageViewportLayout>
    );
};
import { FC } from 'react';
import { PageViewportLayout } from '../template';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useModal } from 'core';
import { Spinner } from '../../pages/projectEdit/spinner';
import { useTheme } from 'styled-components';
import { ErrorPage, ErrorPageButtons } from 'shared/pages/error/ErrorPage';
import { Designer } from '@brg/api';

export const ProjectEditFrameError: FC<{ id: string, isModalProject?: boolean }> = ({ id, isModalProject }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.cannot_edit')}
                buttons={isModalProject ? ErrorPageButtons.NOTHING : ErrorPageButtons.BACK_MAIN}
            />
        </PageViewportLayout>
    );
};

export const ProjectFrameError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.undefined')}
            />
        </PageViewportLayout>
    );
};

export const ProjectEditFrameUpdateError: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.update')}
            />
        </PageViewportLayout>
    );
};

export const ProjectEditFrameLoading: FC<{ id: string, text: string }> = ({ id, text }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout justify={'center'} align={'center'}>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {text || t('project_edit.frames.loading')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const ProjectEditFrameCreating: FC<{ id: string, text: string }> = ({ id, text }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <PageViewportLayout>
            <FlexBox offsetLeftMobile={10} offsetRightMobile={10} offsetTop={40} offsetTopMobile={40} direction='column' directionMobile='column' justify={'center'} align={'center'}>
                <FInter.MainTitleMediumDiv color={theme.projectView.titleColor}>
                    {text || t('project_edit.frames.creating_the_project')}
                </FInter.MainTitleMediumDiv>
                <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
                    {t('project_edit.frames.almost_done')}
                </FInter.TextFlex>
                <FlexBox offsetBottom={16}>
                </FlexBox>
                <Spinner />
            </FlexBox>
        </PageViewportLayout>
    );
};

export const ProjectEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.cannot_edit')}
            />
        </PageViewportLayout>
    );
};

export const TeamEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.cannot_edit_team')}
            />
        </PageViewportLayout>
    );
};

export const TeamEditFrameDeletedTeam: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('teams.adminPage.errors.deleted_team')}
                buttons={ErrorPageButtons.PROFILE}
                id={id}
            />
        </PageViewportLayout>
    );
};

export const TeamEditFrameDraftTeam: FC<{ teamId: string, owner?: Designer }> = ({ teamId, owner }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.undefined')}
                buttons={ErrorPageButtons.BACK_MAIN}
                id={teamId}
            />
        </PageViewportLayout>
    );
};

export const NotFoundChannel: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('teams.adminPage.errors.not_found_channel')}
                buttons={ErrorPageButtons.BACK_MAIN}
            />
        </PageViewportLayout>
    );
};

export const ChatAccessDenied: FC = () => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('teams.adminPage.errors.chat_access_denied')}
                text={t('teams.adminPage.errors.subscribe_to_mediiia')}
                buttons={ErrorPageButtons.CLOSE}
            />
        </PageViewportLayout>
    );
};

export const ChatUnauthorized: FC = () => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('chat.auth.title')}
                text={t('chat.auth.subtitle')}
                buttons={ErrorPageButtons.NEED_AUTH}
            />
        </PageViewportLayout>
    );
};



export const CompetitionEditFrameForbidden: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('competition_edit.frames.forbidden')}
                onBackClick={() => window.open('/', '_SELF')}
            />
        </PageViewportLayout>
    );
};

export const WrongContextForEditFrame: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text={t('project_edit.frames.wrong_context')}
            />
        </PageViewportLayout>
    );
};

export const EditLockedByAuthorFrame: FC<{
    id?: string,
    accaunt?: { name?: string },
    account?: { name?: string },
    editorName?: string,
    entityLabel?: string,
    ownerRole?: string,
}> = ({ id, accaunt, account, editorName, entityLabel = 'модуль', ownerRole = 'автором' }) => {
    const authorName = accaunt?.name || account?.name || editorName || '';
    const history = useHistory();
    const modal = useModal();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title="Редактирование заблокировано"
                text={`На данный момент ${entityLabel} редактируется ${ownerRole}${authorName ? ` - ${authorName}` : ''}`}
                id={id}
                buttons={ErrorPageButtons.MAIN_ONLY}
                onMainClick={() => {
                    modal.hide();
                    history.push('/');
                }}
            />
        </PageViewportLayout>
    );
};



export const ProjectEditFrameCompetition: FC<{ id: string }> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <ErrorPage
                title={t('project_edit.frames.something_went_wrong')}
                text="Проект участвует в конкурсе, его нельзя редактировать."
            />
        </PageViewportLayout>
    );
};

export const ProjectEditFrameCompetitionRequestSended: FC<{ onBackClick: () => void }> = ({ onBackClick }) => {
    const { t } = useTranslation();

    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'} direction='column' directionMobile='column'>
            <ErrorPage
                title={t('project_edit.frames.success')}
                text="Ваша анкета находится на рассмотрении у модератора."
                onBackClick={onBackClick}
            />
        </PageViewportLayout>
    );
};

export const LoadingSpinner: FC = () => {
    return (
        <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
            <Spinner />
        </PageViewportLayout>
    );
};
